import type { ComponentProps } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

export const BadgeGroup = ({ className, ...props }: ComponentProps<"div">) => (
  <Stack
    {...props}
    direction="row"
    gap={0}
    role="group"
    data-slot="badge-group"
    className={cn(
      "w-fit max-w-full min-w-0 items-stretch overflow-hidden rounded-md bg-neutral",
      className,
    )}
  />
);
